module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('el-row', {
    staticClass: "gPageBorder  gPdTB"
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_serialnumber')
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.authDetail.terminalNo) + "\n\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_model')
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.authDetail.modelName) + "\n\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowLeftForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('lin_global.status')
    }
  }, [_c('el-tag', {
    attrs: {
      "type": _vm.authDetail.status == 1 ? 'success' : 'danger'
    }
  }, [_vm._v(_vm._s(_vm.formatStatus(_vm.authDetail.status)))])], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form', {
    staticClass: "gShowRightForm",
    attrs: {
      "label-position": "left",
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('app_authcode')
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.authDetail.activationCode) + "\n\t\t\t\t")])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "gTopMg gPageBorder"
  }, [_c('el-row', {
    staticStyle: {
      "margin-bottom": "24px"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-button', {
    staticClass: "gSgLeftBtn",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.getList(1)
      }
    }
  }, [_vm._v("\n\t\t\t\t\t" + _vm._s(_vm.$t('lin_global.shuaxin')) + "\n\t\t\t\t")])], 1)], 1), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.arrdata,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "optTime",
      "label": _vm.$t('app_udtime')
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "label": _vm.$t('app_authstat'),
      "formatter": _vm.formatListStatus,
      "show-overflow-tooltip": true
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ec11cd7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/safe/authorizeDetail.vue
// module id = 966
// module chunks = 0